// import 'typeface-lato'

import React from 'react'
import styled, { injectGlobal } from 'react-emotion'
import { fontSize } from 'styled-system'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'emotion-theming'
// import Intercom, { IntercomAPI } from 'react-intercom'

import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
import colors from '../utils/colors'

/* eslint-disable */
import normalize from 'normalize.css'
injectGlobal`
@import url('https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i');
  * {
      ${
        '' /* font-family: -apple-system, BlinkMacSystemFont,
             'avenir next', avenir,
             'helvetica neue', helvetica,
             ubuntu,
             roboto, noto,
             'segoe ui', arial,
             sans-serif; */
      }
      font-family: Lato, sans-serif;
      box-sizing: border-box;
  };
  a {
    text-decoration: none;
    color: ${colors.accent};
  };
  a:hover {
    cursor: pointer;
    text-decoration: underline;
  };
  h1, h2, h3, h4, h5, h6, p {
    color: ${colors.secondary}
  };
`
/* eslint-enable */

const FontConfig = styled.div`
  ${fontSize};
`

const theme = {
  breakpoints: ['675px', '1000px'],
}

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <FontConfig fontSize={[2, 3, 4]}>
      <Navigation />
      {children()}
      {/* <Footer /> */}
      {/* <Intercom appID="ev2s4vgt" /> */}
    </FontConfig>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.func.isRequired,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js